// extracted by mini-css-extract-plugin
module.exports = {"resumeContainer":"KResumeKPI_resumeContainer__2VaJb"};